import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { ConnectorGroup } from 'models/ConnectorGroup';

type AddConnectorGroupFormProps = {
  show: boolean;
  handleClose: () => void;
  handleSave: (connectorGroup: ConnectorGroup) => void;
};

const REQUIRED_FIELD_MESSAGE = 'Please fill out this field.';

const ConnectorGroupAddForm: React.FC<AddConnectorGroupFormProps> = ({ show, handleClose, handleSave }) => {
  const [newConnectorGroup, setNewConnectorGroup] = React.useState<ConnectorGroup>({
    id: 0,
    name: '',
    display_name: '',
  });
  const [fieldErrors, setFieldErrors] = React.useState<Record<string, string[]>>({});

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setNewConnectorGroup({ ...newConnectorGroup, [name]: value });
    if (fieldErrors[name]) {
      setFieldErrors((prev) => {
        const next = { ...prev };
        delete next[name];
        return next;
      });
    }
  };

  const handleSubmit = () => {
    const trimmedName = newConnectorGroup.display_name.trim();
    if (!trimmedName) {
      setFieldErrors({ display_name: [REQUIRED_FIELD_MESSAGE] });
      return;
    }

    setFieldErrors({});
    handleSave({ ...newConnectorGroup, display_name: trimmedName });
    handleClose();
  };

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    handleSubmit();
  };

  const handleCloseAndReset = () => {
    setFieldErrors({});
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleCloseAndReset}>
      <Form noValidate onSubmit={handleFormSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Group</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="formDisplayName">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              name="display_name"
              value={newConnectorGroup.display_name}
              onChange={handleChange}
              isInvalid={Boolean(fieldErrors.display_name)}
            />
            {fieldErrors.display_name && (
              <Form.Control.Feedback type="invalid">
                {fieldErrors.display_name.join(' ')}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" type="button" onClick={handleCloseAndReset}>
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ConnectorGroupAddForm;
